import React from "react";
import PeopleIcon from "@mui/icons-material/People";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PaymentIcon from "@mui/icons-material/Payment";
import QuizIcon from "@mui/icons-material/Quiz";
import StoreIcon from '@mui/icons-material/Store';


const menus = [
  {
    label: "sidebar.menu.myBranch",
    type: "section",
    children: [
      {
        uri: "/dashboards/myBranch",
        label: "sidebar.menuItem.myBranch",
        type: "nav-item",
        icon: <StoreIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.purchaseOrder",
    type: "section",
    children: [
      {
        uri: "/dashboards/purchaseOrder",
        label: "sidebar.menuItem.purchaseOrder",
        type: "nav-item",
        icon: <PeopleIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.inventory",
    type: "section",
    children: [
      {
        uri: "/dashboards/inventory",
        label: "sidebar.menuItem.inventory",
        type: "nav-item",
        icon: <Inventory2OutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.salesOrder",
    type: "section",
    children: [
      {
        uri: "/dashboards/salesOrder",
        label: "sidebar.menuItem.salesOrder",
        type: "nav-item",
        icon: <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  {
    label: "sidebar.menu.payment",
    type: "section",
    children: [
      {
        uri: "/dashboards/payment",
        label: "sidebar.menuItem.payment",
        type: "nav-item",
        icon: <PaymentIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.faqs",
    type: "section",
    children: [
      {
        uri: "/dashboards/faqs",
        label: "sidebar.menuItem.faqs",
        type: "nav-item",
        icon: <QuizIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
];

export default menus;
